import forEach from '../../../../javascripts/dom/forEach';
import { tns } from '../../../../../node_modules/tiny-slider/src/tiny-slider.module';

const partnerSlider = document.querySelectorAll('[data-js-module="o-partner"]');

const init = async => {
  forEach(partnerSlider, (index, element) => {
    const container = element.querySelector('.o-partner-wrapper');
    const controlsContainer = element.parentNode.querySelector('.o-partner-controls');
    tns({
      container,
      items: 7,
      mode: 'carousel',
      nav: false,
      gutter: 25,
      mouseDrag: true,
      center: true,
      speed: 400,
      controlsContainer,
      responsive: {
        250: {
          items: 1
        },
        768: {
          items: 3
        },
        1280: {
          items: 7
        }
      }
    });
  });
};

if (partnerSlider) {
  init();
}
